module.exports = __webpack_public_path__ + "img/beijingtu (4).0c5bd44f.png";